// extracted by mini-css-extract-plugin
module.exports = {"SolarEnergy":"SolarEnergy_SolarEnergy__epTBm"};